export function registerPwa() {
  if (
    process.env.NODE_ENV !== "production" ||
    !("serviceWorker" in navigator)
  )
    return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/pwa-service-worker.js", {
        scope: "/",
        updateViaCache: "none"
      })
      .then(registration => {
        registration.update();
        registration.addEventListener("updatefound", () => {
          const worker = registration.installing;
          if (!worker) return;
          worker.addEventListener("statechange", () => {
            if (
              worker.state === "installed" &&
              navigator.serviceWorker.controller
            ) {
              window.dispatchEvent(new Event("mangusta-pwa-update"));
            }
          });
        });
      })
      .catch(error => {
        console.error("Nie udało się zarejestrować aplikacji PWA:", error);
      });
  });
}



// WEBPACK FOOTER //
// ./src/registerPwa.js